const sectionCls = "c2lsbmmobn";
const goBackCls = "c2lg697i7y";
const headerCls = "c2lh1o7zndg";
const transitionDurationMs = 250;
const transitionCls = "c2lt1e0w8a6";
const inputCls = "c2liqd8oe8";
const separatorCls = "c2lsx4ve1c";

export { goBackCls, headerCls, inputCls, sectionCls, separatorCls, transitionCls, transitionDurationMs };
import "./_course-page.style.linaria.module.css";
//# sourceMappingURL=_course-page.style.js.map
